'use strict'

const maybe = require('folktale/maybe')
const isPlainObject_ = require('lodash/isPlainObject')

const { resolveDynamicProperties } = require('./dynamicProperties')
const emptyConnectionConfig = require('../helpers/emptyConnectionConfig')
const componentTypes = require('dbsm-common/src/componentTypes')

const swapComponentByTypeHandlers = {
  [componentTypes.Page]: ({ $w }) => $w('Document')
}

const createAdapterContext = ({ getFieldType, role, component, $w, api }) => {
  const swapComponentByType = swapComponentByTypeHandlers[component.type]
  const connectionConfig = maybe
    .fromNullable(component.connectionConfig)
    .filter(isPlainObject_)
    .map(connectionConfig =>
      resolveDynamicProperties({ connectionConfig }, role, getFieldType)
    )
    .getOrElse(emptyConnectionConfig)

  const adapterContext = {
    role,
    connectionConfig,
    component: swapComponentByType ? swapComponentByType({ $w }) : component,
    api
  }

  return adapterContext
}

module.exports.createAdapterContext = createAdapterContext



// WEBPACK FOOTER //
// ./components/context.js